<script setup>
import Layout from "./components/layouts/StandardLayout.vue";
import {useRoute} from 'vue-router'
const route=useRoute();

</script>
<template>
  <Layout v-if="route.fullPath.includes('/admin')"/>
  <router-view v-else></router-view>
</template>
<style>
html {
  overflow: auto;
}
</style>